/**
 * Identity Display API Service — IDENTITY:P3.A
 *
 * API client for identity display endpoints (composite identity resolution).
 * Uses fetchAPI wrapper for auth headers and CSRF tokens.
 */
import { fetchAPI } from './api';

const PREFIX = '/identity/display';

/**
 * GET /identity/display — Get current user's composite display identity.
 * @returns {Promise<Object>} DisplayIdentityResponse
 */
export async function getDisplayIdentity() {
  return fetchAPI(PREFIX);
}

/**
 * GET /identity/display/{userId} — Admin: get display identity for a specific user.
 * @param {string} userId - UUID of the target user
 * @returns {Promise<Object>} DisplayIdentityResponse
 */
export async function getDisplayIdentityAdmin(userId) {
  return fetchAPI(`${PREFIX}/${encodeURIComponent(userId)}`);
}

/**
 * POST /identity/display/batch — Batch resolve display identities for multiple users.
 * @param {string[]} userIds - Array of user UUIDs
 * @returns {Promise<Object>} BatchDisplayIdentityResponse
 */
export async function batchResolveIdentities(userIds) {
  return fetchAPI(`${PREFIX}/batch`, {
    method: 'POST',
    body: JSON.stringify({ user_ids: userIds }),
  });
}
